/**
 * @generated SignedSource<<2ba599ad4581caf18073a5f8c3a006b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegateProfileImageFragment$data = {
  readonly liquidRepresentation: ReadonlyArray<{
    readonly proxy: {
      readonly nounsRepresented: ReadonlyArray<{
        readonly __typename: "Noun";
      }>;
    };
  }>;
  readonly tokensRepresented: {
    readonly amount: {
      readonly amount: string;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"NounGridFragment">;
  readonly " $fragmentType": "DelegateProfileImageFragment";
};
export type DelegateProfileImageFragment$key = {
  readonly " $data"?: DelegateProfileImageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DelegateProfileImageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DelegateProfileImageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VotingPower",
      "kind": "LinkedField",
      "name": "tokensRepresented",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TokenAmount",
          "kind": "LinkedField",
          "name": "amount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "currentlyActive": true
          }
        }
      ],
      "concreteType": "LiquidDelegationRepresentation",
      "kind": "LinkedField",
      "name": "liquidRepresentation",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Delegate",
          "kind": "LinkedField",
          "name": "proxy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Noun",
              "kind": "LinkedField",
              "name": "nounsRepresented",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "liquidRepresentation(filter:{\"currentlyActive\":true})"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NounGridFragment"
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "7a44b04983bf0bc43254f903054dd2ed";

export default node;
